
<div *ngIf="!hasBeenRequest" class="btn-track chip d-inline-block px-2 py-1" (click)="onRequestClick()">
    <div class="d-flex flex-row align-items-center">
        <div class="typo-chip px-2">{{ 'wap1_c_barcode_request' | translate }}</div>
        <img class="picto-small" src="../../../assets/images/231116/pictos/Request.svg" />
    </div>
</div>
<div *ngIf="hasBeenRequest" class="typo-chip px-2 py-1 pre-line">
    {{ 'wap1_c_barcode_requestThanks' | translate }}
</div>